/* unplugin-vue-components disabled */import script from "./OrderCustomerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCustomerCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderCustomerCard.vue?vue&type=style&index=0&id=70b0495f&lang=scss"

const __exports__ = script;

export default __exports__